import { defineComponent as _defineComponent } from 'vue'
import type { TitleDetail, TitleDetailSeason } from '@/interfaces/title-details-graphql';
import type { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';

import { OfferPresentationType } from '@/interfaces/titles';

import NoOfferBell from '@/features/buybox/components/grid/NoOfferBell.vue';
import { useLanguageStore, useUserStore } from '@/helpers/composables/useStores';

import { computed, inject, ref, watch } from 'vue';
import { useListActions } from '@/helpers/composables/useListActions';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoOfferRow',
  props: {
    title: null,
    titleHasNoOffers: { type: Boolean },
    isTitleInWatchlist: { type: Boolean, default: false },
    inline: { type: Boolean },
    isEpisodeBuybox: { type: Boolean },
    episodeBuyBoxPresentationType: { default: null },
    compact: { type: Boolean }
  },
  emits: ["onWatchlistToggle"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'onWatchlistToggle', createdAt: string | null): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { title: TitleDetail | TitleDetailSeason, titleHasNoOffers: boolean, isTitleInWatchlist: boolean, inline?: boolean, isEpisodeBuybox?: boolean, episodeBuyBoxPresentationType: OfferPresentationType | null, compact?: boolean };





const { isTTBLanguage } = useLanguageStore();
const { buyboxPresentationType, isLoggedIn } = useUserStore();

/** Filtering for free offers but this title does have other offers */
const displayNoFreeOffers = computed(() => {
	if (props.isEpisodeBuybox)
		return props.episodeBuyBoxPresentationType === OfferPresentationType.FREE && !props.titleHasNoOffers;

	return buyboxPresentationType.value === OfferPresentationType.FREE && !props.titleHasNoOffers;
});

const { tc } = useI18n();
const noFreeOfferCTA = computed(() =>
	props.isTitleInWatchlist ? tc('WEBAPP_WATCHLIST_FREE_ALREADY_ADDED') : tc('WEBAPP_WATCHLIST_FREE_CTA')
);

const titleDetails = computed(() => {
	const title = props.title.__typename === 'Season' ? props.title.show : props.title;

	return {
		title: title.content.title,
		objectType: title.objectType,
		objectId: title.objectId,
	};
});

const { onIsLoggedInChange, setInWatchlist } = useListActions();

const titleContext = inject('titleContext', ref<SnowplowTitleContextGraphql | null>(null));

const id = computed(() => (props.title.__typename === 'Season' ? props.title.show.id : props.title.id));
async function onNotifyMe() {
	const updatedTitle = await setInWatchlist(id.value, props.isTitleInWatchlist, titleDetails.value, {
		source: 'buybox',
	});

	if (updatedTitle) {
		emits('onWatchlistToggle', updatedTitle.data?.setInWatchlistV2.title.watchlistEntryV2?.createdAt);
	}
}

watch(isLoggedIn, () => onIsLoggedInChange(id.value, titleDetails.value, props.isTitleInWatchlist, 'buybox'));

return { __sfc: true,props, emits, isTTBLanguage, buyboxPresentationType, isLoggedIn, displayNoFreeOffers, tc, noFreeOfferCTA, titleDetails, onIsLoggedInChange, setInWatchlist, titleContext, id, onNotifyMe, NoOfferBell }
}

})